export default __webpack_public_path__ + "static/media/miguel-perales.f526fb90.jpg";